const getSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form.querySelectorAll('[product-option] input[type="radio"]:checked').forEach(option => {
    selectedValues.push({
      value: option.value,
      index: option.name
    });
  });

  const variant = product.variants.find(variant => {
    return selectedValues.every(value => {
      return variant[value.index] == value.value;
    });
  });

  if (variant) {
    idField.value = variant.id;
    submit.disabled = !variant.available;
  } else {
    idField.value = '';
    submit.disabled = true;
  }

  return variant;
};

const setupImageSlider = (tile) => {
  const slider = tile.querySelector('.product-tile__images');
  if (!slider || slider.dataset.sliderInit) return;

  const track = slider.querySelector('[data-slider-track]');
  const slides = slider.querySelectorAll('[data-slide]');
  const progressItems = slider.querySelectorAll('[data-progress-item]');
  const prevButton = slider.querySelector('[data-slider-prev]');
  const nextButton = slider.querySelector('[data-slider-next]');
  const tileLink = tile.querySelector('a[data-ajaxinate-product-id]');
  slider.dataset.sliderInit = 'true';

  let currentIndex = 0;
  let touchStartX = 0;
  let touchDeltaX = 0;
  let isDragging = false;
  let preventClick = false;

  slider.addEventListener('click', (event) => {
    if (!tileLink || preventClick) return;

    if (event.target.closest('[data-slider-prev], [data-slider-next], [data-progress-item], .product-tile__images__hover')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(tileLink.href);
  });

  if (!track || slides.length <= 1) return;

  const suppressLinkNavigation = (element) => {
    if (!element) return;

    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
      element.addEventListener(eventName, (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });
  };

  const setActiveSlide = (index) => {
    const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
    currentIndex = nextIndex;

    track.style.transform = `translateX(-${nextIndex * 100}%)`;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === nextIndex);
    });

    progressItems.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === nextIndex);
    });
  };

  progressItems.forEach((item) => {
    suppressLinkNavigation(item);

    item.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setActiveSlide(Number(item.dataset.slideTarget || 0));
    });
  });

  [prevButton, nextButton].forEach((button) => {
    suppressLinkNavigation(button);
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      setActiveSlide(currentIndex - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      setActiveSlide(currentIndex + 1);
    });
  }

  slider.addEventListener('touchstart', (event) => {
    touchStartX = event.touches[0]?.clientX || 0;
    touchDeltaX = 0;
    isDragging = true;
  }, { passive: true });

  slider.addEventListener('touchmove', (event) => {
    if (!isDragging) return;
    touchDeltaX = (event.touches[0]?.clientX || 0) - touchStartX;
  }, { passive: true });

  slider.addEventListener('touchend', () => {
    if (!isDragging) return;

    if (Math.abs(touchDeltaX) > 24) {
      preventClick = true;
      setActiveSlide(currentIndex + (touchDeltaX < 0 ? 1 : -1));
      window.setTimeout(() => {
        preventClick = false;
      }, 180);
    }

    isDragging = false;
    touchDeltaX = 0;
  });

  if (tileLink) {
    tileLink.addEventListener('click', (event) => {
      if (!preventClick) return;
      event.preventDefault();
      event.stopPropagation();
    });
  }

  setActiveSlide(0);
};

if (!window.pingInit) window.pingInit = {};
window.pingInit.initProductTile = (tile) => {
  if (!tile) return;

  setupImageSlider(tile);

  const tileHover = tile.querySelector('.product-tile__hover');
  if (tileHover) {
    if (tileHover.classList.contains('product-tile__hover--color')) {
      const $dots = $(tile).find('.product-tile__hover--color__dot:not([selected])');
      if ($dots.length > 0) {
        $dots.each(function () {
          $(this).on('mouseenter', function () {
            if ($(window).width() <= 768) return;

            const $colorNames = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name]');
            if ($colorNames.length > 0) {
              $colorNames.css('opacity', '0');
            }

            const $hoveredColor = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name="' + $(this).data('colorName') + '"]');
            if ($hoveredColor.length > 0) {
              $hoveredColor.css('opacity', '1');
            }
          });

          $(this).on('mouseleave', function () {
            if ($(window).width() <= 768) return;

            const $colorNames = $(this).closest('.product-tile__hover--color').find('.product-tile__hover--color__name[data-color-name]');
            if ($colorNames.length > 0) {
              $colorNames.css('opacity', '');
            }
          });
        });
      }
    } else {
      const hoverOpener = tile.querySelector('.product-tile__meta__form-opener');
      if (hoverOpener) {
        hoverOpener.addEventListener('click', () => {
          hoverOpener.classList.toggle('open');
          tileHover.classList.toggle('open');
        });
      }

      const productForm = tileHover.querySelector('.product-tile__hover--quick-buy__form');
      if (!productForm) return;
      const productJsonScript = productForm.querySelector('[product-json]');
      const idField = productForm.querySelector('input[name="id"]');
      if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim()) return;
      const product = JSON.parse(productJsonScript.innerHTML.trim());
      getSelectedVariant(productForm, product);

      productForm.addEventListener('change', () => {
        getSelectedVariant(productForm, product);
      });

      productForm.addEventListener('submit', e => {
        e.preventDefault();
        if (typeof (ShopifyAPI) !== 'undefined' && typeof (ShopifyAPI.addItemFromForm) !== 'undefined') {
          ShopifyAPI.addItemFromForm(
            productForm,
            () => {
              productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label.open').forEach(openFieldset => {
                openFieldset.classList.remove('open');
              });

              if (typeof (theme.settings.cartType) === 'undefined' || theme.settings.cartType === 'drawer') {
                if (typeof (ShopifyAPI.getCart) !== 'undefined') {
                  ShopifyAPI.getCart(() => {
                    if (typeof (ajaxCart) !== 'undefined' && typeof (ajaxCart.load) !== 'undefined') {
                      ajaxCart.load();
                    }
                  });
                }
              } else {
                ajaxCart.load();
              }
            }
          );
        } else {
          productForm.submit();
        }
      });

      productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label').forEach(fieldsetOpener => {
        fieldsetOpener.addEventListener('click', () => {
          if (fieldsetOpener.classList.contains('open')) {
            fieldsetOpener.classList.remove('open');
          } else {
            productForm.querySelectorAll('.product-tile__hover--quick-buy__form__option > label.open').forEach(openFieldset => {
              openFieldset.classList.remove('open');
            });
            fieldsetOpener.classList.add('open');
          }
        });
      });
    }
  }
};

window.pingInit.initProductTiles = (rootElement = document) => {
  if (!rootElement || !rootElement.querySelectorAll) return;

  rootElement.querySelectorAll('.product-tile__container').forEach((tile) => {
    window.pingInit.initProductTile(tile);
  });
};

if (document.readyState != "loading") {
  window.pingInit.initProductTiles(document);
} else {
  document.addEventListener('DOMContentLoaded', () => {
    window.pingInit.initProductTiles(document);
  });
}
